import {
  WSTable,
  WSTableColumnSortDirection
} from "@wingspanhq/fe-component-library";
import { IInvoice, IWorkLog } from "@wingspanhq/payments/dist/interfaces";
import { useMemo } from "react";
import { IPayerRow } from "../../../../services/search";
import { getColumns } from "./columns";

export type TableItemData = IWorkLog;

type Props = {
  workLogs: IWorkLog[];
  payersMap: Map<string, IPayerRow>;
  invoicesMap?: Map<string, IInvoice>;
  onRowClick?: (workLog: IWorkLog) => void;
  onSortByUpdatedAt: (newDirection: WSTableColumnSortDirection) => void;
  updatedAtDirection?: WSTableColumnSortDirection;
};

export const TableWorkLogsPayeeView: React.FC<Props> = props => {
  const tableData = useMemo(() => {
    return props.workLogs.map(workLog => ({
      id: workLog.workLogId,
      data: workLog
    }));
  }, [props.workLogs]);

  const columns = useMemo(
    () =>
      getColumns({
        payersMap: props.payersMap,
        invoicesMap: props.invoicesMap,
        onSortByUpdatedAt: props.onSortByUpdatedAt,
        updatedAtDirection: props.updatedAtDirection
      }),
    [
      props.payersMap,
      props.invoicesMap,
      props.onSortByUpdatedAt,
      props.updatedAtDirection
    ]
  );

  return (
    <WSTable<TableItemData>
      tableData={tableData}
      columns={columns}
      onRowClick={
        props.onRowClick ? item => props.onRowClick!(item.data) : undefined
      }
    />
  );
};
